import { AuthRoutes } from '@qse/constants'

export const AppRoutesList = {
  ...AuthRoutes, // merge auth routes

  // public routes
  checkInvitation: '/check-invitation/:tenantId/:invitationCode',
  accountDeletion: '/account-deletion',

  // Dashboard-specific routes
  dashboard: '/dashboard',
  trash: '/dashboard/trash',
  generateEntropy: '/dashboard/generate-entropy',
  generateKeys: '/dashboard/generate-keys',
  favorites: '/dashboard/favorites',
  searchResults: '/dashboard/search-results',
  folder: '/folders/:id',
  reseller: '/dashboard/management/reseller',

  // Admin-only routes
  tenant: '/dashboard/management/tenant/:id',
  users: '/dashboard/management/users',

  // Billing routes (shared between admin and dashboard)
  billing: '/billing',
  success: '/billing/success',
} as const
